import {
  SET_MATURANDO_PROFILE,
  SET_READINESS_SCORE,
  SET_MATURITA_EXAM_SESSION,
  UPDATE_MATURITA_PHASE,
  RESET_MATURITA_EXAM,
} from '../actions/types';

const initialState = {
  profile: null,       // { isMaturando, indirizzo, materie[], examDate, onboardingCompleted }
  readiness: null,     // { overall, perSubject: {}, lastActivity, daysUntilExam, isPanicMode }
  currentExam: null,   // { id, startedAt, phases: {}, currentPhaseIndex }
  currentPhase: null,  // { id, numero, status, results }
  loading: false,
};

const maturitaReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MATURANDO_PROFILE:
      return {
        ...state,
        profile: action.payload,
      };

    case SET_READINESS_SCORE:
      return {
        ...state,
        readiness: action.payload,
      };

    case SET_MATURITA_EXAM_SESSION:
      return {
        ...state,
        currentExam: action.payload,
        currentPhase: action.payload?.currentPhaseIndex != null
          ? { index: action.payload.currentPhaseIndex }
          : null,
      };

    case UPDATE_MATURITA_PHASE:
      return {
        ...state,
        currentPhase: {
          ...state.currentPhase,
          ...action.payload,
        },
        currentExam: state.currentExam
          ? {
              ...state.currentExam,
              phases: {
                ...state.currentExam.phases,
                [action.payload.id]: action.payload,
              },
            }
          : null,
      };

    case RESET_MATURITA_EXAM:
      return {
        ...state,
        currentExam: null,
        currentPhase: null,
      };

    default:
      return state;
  }
};

export default maturitaReducer;
